import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useTranslation } from "react-i18next";
import "./table.css";
import * as XLSX from "xlsx";


export default function PresortDemo({
	column,
	data,
	isLoading,
	toggleSidebar,
	actions,
	expandedRows = [],
	footer,
	footerColumnGroup,
	id = 'guid',
	paginator = false,
	exportExcelBool = false,
	rows = 20,
	rowsPerPageOptions = [100],
	lastGuid,
	...props
}) {
	// const [newData, setNewData] = useState(null);
	const { t } = useTranslation();
	const dtRef = useRef(null); // 👈 реф для DataTable
	const [filteredData, setFilteredData] = useState(null);
	const numberBodyTemplate = (rowData, options) => options.rowIndex + 1;

	const exportCSV = (selectionOnly) => {
		dtRef.current.exportCSV({ selectionOnly });
	};

	const exportExcel = () => {
		if (!Array.isArray(column)) return;

		const rows = Array.isArray(filteredData) && filteredData.length
			? filteredData
			: data;

		const sourceData = rows.map(row => {
			const newData = {};

			column.forEach(col => {
				let value = row[col.attr];

				// Если колонка типа date и значение есть
				if (col.dateType === 'date' && value) {
					const dateObj = new Date(value);
					value = isNaN(dateObj.getTime()) ? value : dateObj.toDateString();
				}

				newData[col.attr] = value;
			});

			return newData;
		});

		const worksheet = XLSX.utils.json_to_sheet(sourceData);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'data');

		XLSX.writeFile(
			workbook,
			`export_${new Date().toISOString().slice(0, 10)}.xlsx`
		);
	};

	const header = (
		<div className="flex align-items-center justify-content-end gap-2" style={{ display: "flex", gap: 12, alignItems: "center", padding: "0 12px", position: "absolute", bottom: "-28px", left: 0 }}>
			<Button type="button" icon="pi pi-file" label='CSV' onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />
			<Button type="button" icon="pi pi-file-excel" severity="success" label='Excel' onClick={exportExcel} data-pr-tooltip="XLS" />
		</div>
	);

	const rowClassName = (rowData) => {
		if (rowData?.guid === lastGuid) {
			return 'last-added-row';
		}
		return '';
	};



	return (
		<div className="card" style={{ position: "relative" }}>
			<DataTable
				ref={dtRef} // 👈 привязываем реф
				value={data}
				loading={isLoading}
				onRowDoubleClick={(currentData) => toggleSidebar(true, currentData.data)}
				id={id}
				onValueChange={(data) => setFilteredData(data)}
				key={id}
				resizableColumns
				rowClassName={rowClassName}   // 👈 добавляем
				expandedRows={
					column
						.filter(el => el.attr !== "guid")
						.map(({ label, attr, ...params }) => (
							<Column
								key={attr}
								field={attr}
								header={label}
								sortable
								filterHeaderClassName="filter-header"
								minWidth="160px"
								filter
								dataType={params?.dateType ?? "text"}
								filterElement={params?.filterTemplate}
								style={{
									maxWidth: params?.maxWidth ?? '150rem',
								}}
								{...params}
								{...(params.body && {
									body: (data, ...props) => params.body(data, t, ...props),
								})}
							/>
						))
				}
				reorderableRows
				dataKey="guid"
				size="small"
				width="calc(100vw - 68px)"
				tableStyle={{ minWidth: '50rem', maxWidth: 'calc(100vw - 80px)', fontSize: '12px' }}
				scrollable
				filterDisplay="row"
				scrollHeight={props.height ?? "calc(100vh - 80px)"}
				footer={footer}
				footerColumnGroup={footerColumnGroup}
				paginator={paginator}
				rows={rows}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink"
				currentPageReportTemplate="{first} - {last} из {totalRecords}"
				{...props}
			>
				<Column header="#" body={numberBodyTemplate} style={{ width: '3rem' }} />
				{!!actions && (
					<Column
						sortable={false}
						style={{ minWidth: '1rem' }}
						{...actions}
						header=""
					/>
				)}
				{column
					.filter(el => el.attr !== "guid")
					.map(({ label, attr, ...params }) => (
						<Column
							key={attr}
							field={attr}
							header={label}
							sortable
							filterHeaderClassName="filter-header"
							minWidth="160px"
							filter
							dataType={params?.dateType ?? "text"}
							filterElement={params?.filterTemplate}
							style={{
								maxWidth: params?.maxWidth ?? '150rem',
								minWidth: params?.minWidth ?? "120px",
							}}
							{...params}
							{...(params.body && {
								body: (data, ...props) => params.body(data, t, ...props),
							})}
						/>
					))}
			</DataTable>
			{header}
		</div>
	);
}
